"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _stores = require("@seedlang/stores");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var formatMembershipTitle = function formatMembershipTitle(title) {
  return title === null || title === void 0 ? void 0 : title.replace(/Member$/, 'Membership');
};
var SettingsBillingWrapper = function SettingsBillingWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "loading", _descriptor, _this);
      _this.loadSubscriptions = function () {
        if (!_state.AppUI.userIsSignedIn) return;
        _this.loading = true;
        _state.AppUI.userSubscriptionStore.getIndex({}, function (resp) {
          _this.loading = false;
          _state.AppUI.userSubscriptionStore.afterGetIndex(resp);
        });
      };
      _this.loadSubscriptions();
      _stores.SiteStore.getIndex({
        queryStrings: {
          basic: true
        }
      });
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "activeSubscription",
      get: function get() {
        if (!_state.AppUI.userSubscriptionStore.hasIndexData) {
          return {};
        }
        if (_state.AppUI.siteIsSeedlang) {
          var activeSubscriptions = (0, _lodash.orderBy)(_state.AppUI.userSubscriptionStore.indexData.filter(function (s) {
            return !s.pending && s.isActive;
          }), ['currentPeriodStart.date'], ['desc']);
          return activeSubscriptions[0] || {};
        }
        if ((0, _utils.isPresent)(_state.AppUI.user.currentGroupMembershipType)) {
          var subscriptions = _state.AppUI.userSubscriptionStore.indexData.filter(function (item) {
            var _item$membership;
            return ((_item$membership = item.membership) === null || _item$membership === void 0 ? void 0 : _item$membership.membershipTypeId) === _state.AppUI.user.currentGroupMembershipType.id;
          });

          // Priority: active non-cancelled > trialing > any active
          var activeNotCancelled = (0, _lodash.last)(subscriptions.filter(function (s) {
            return s.isActive && !s.cancelAt;
          }));
          if (activeNotCancelled) return activeNotCancelled;
          var trialing = (0, _lodash.last)(subscriptions.filter(function (s) {
            return s.isTrialing;
          }));
          if (trialing) return trialing;
          var active = (0, _lodash.last)(subscriptions.filter(function (s) {
            return s.isActive;
          }));
          if (active) return active;
        }
        return {};
      }
    }, {
      key: "activeStripeSubscriptionExists",
      get: function get() {
        return this.activeSubscription && this.activeSubscription.paymentMethod === 'stripe';
      }
    }, {
      key: "activeSubscriptionIsMobile",
      get: function get() {
        return (0, _utils.isPresent)(this.activeSubscription) && ['ios', 'android'].includes(this.activeSubscription.paymentMethod);
      }
    }, {
      key: "mostRecentPaymentMethod",
      get: function get() {
        return (0, _utils.isPresent)(this.activeSubscription) ? this.activeSubscription.paymentMethod : null;
      }
    }, {
      key: "userSubscriptions",
      get: function get() {
        return _state.AppUI.userSubscriptionStore.indexData.filter(function (item) {
          var _item$cancelledAt;
          return item.siteId === _state.AppUI.site.id && !(item.pending && (0, _utils.isPresent)((_item$cancelledAt = item.cancelledAt) === null || _item$cancelledAt === void 0 ? void 0 : _item$cancelledAt.date));
        });
      }
    }, {
      key: "showCancelButton",
      get: function get() {
        var subscription = this.activeSubscription;
        return _state.AppUI.user.isMember && (0, _utils.isPresent)(subscription) && !subscription.oneTimePayment && !subscription.cancelAt && !(_state.AppUI.siteIsSeedlang && (_state.AppUI.user.temporaryFreeMembership || _state.AppUI.user.permanentMembership));
      }
    }, {
      key: "subscriptionStatusText",
      get: function get() {
        var _subscription$current, _subscription$members, _subscription$nextPha, _subscription$cancelA, _subscription$current2, _subscription$cancelA2;
        var subscription = this.activeSubscription;
        if (!(0, _utils.isPresent)(subscription) || subscription.oneTimePayment) return null;
        if (!(0, _utils.isPresent)((_subscription$current = subscription.currentPeriodEnd) === null || _subscription$current === void 0 ? void 0 : _subscription$current.formattedDateWithYear)) return null;
        var title = formatMembershipTitle((_subscription$members = subscription.membership) === null || _subscription$members === void 0 ? void 0 : _subscription$members.title);
        var formattedEnd = subscription.currentPeriodEnd.formattedDateWithYear;
        if (!subscription.cancelAt && (0, _utils.isPresent)((_subscription$nextPha = subscription.nextPhaseMembership) === null || _subscription$nextPha === void 0 ? void 0 : _subscription$nextPha.title)) {
          var _subscription$nextPha2, _subscription$nextPha3;
          var nextTitle = formatMembershipTitle((_subscription$nextPha2 = subscription.nextPhaseMembership) === null || _subscription$nextPha2 === void 0 ? void 0 : _subscription$nextPha2.title);
          var nextFrequency = ((_subscription$nextPha3 = subscription.nextPhaseMembership) === null || _subscription$nextPha3 === void 0 ? void 0 : _subscription$nextPha3.numberMonths) === 12 ? 'yearly' : 'monthly';
          var nextPlanLabel = _state.AppUI.siteIsSeedlang ? nextTitle : "".concat(nextFrequency, " ").concat(nextTitle);
          return "Your ".concat(title, " is active and will turn into a ").concat(nextPlanLabel, " on ").concat(formattedEnd, ".");
        }
        if (!subscription.cancelAt) {
          return "Your ".concat(title, " is active and will renew on ").concat(formattedEnd, ".");
        }
        var cancelAtDiffersFromPeriodEnd = ((_subscription$cancelA = subscription.cancelAt) === null || _subscription$cancelA === void 0 || (_subscription$cancelA = _subscription$cancelA.date) === null || _subscription$cancelA === void 0 ? void 0 : _subscription$cancelA.getTime()) !== ((_subscription$current2 = subscription.currentPeriodEnd) === null || _subscription$current2 === void 0 || (_subscription$current2 = _subscription$current2.date) === null || _subscription$current2 === void 0 ? void 0 : _subscription$current2.getTime());
        if (cancelAtDiffersFromPeriodEnd && (_subscription$cancelA2 = subscription.cancelAt) !== null && _subscription$cancelA2 !== void 0 && _subscription$cancelA2.formattedDateWithYear) {
          var _subscription$members2;
          var frequency = ((_subscription$members2 = subscription.membership) === null || _subscription$members2 === void 0 ? void 0 : _subscription$members2.numberMonths) === 12 ? 'yearly' : 'monthly';
          return ["Your subscription is scheduled to be cancelled on ".concat(subscription.cancelAt.formattedDateWithYear, "."), "Until then, it will renew ".concat(frequency, ", next on ").concat(formattedEnd, ".")].join(' ');
        }
        return "Your subscription is cancelled. You will retain access until ".concat(formattedEnd, ", and it will not renew.");
      }
    }, {
      key: "cancellationNoticeText",
      get: function get() {
        var _this$activeSubscript;
        var formattedEnd = (_this$activeSubscript = this.activeSubscription) === null || _this$activeSubscript === void 0 || (_this$activeSubscript = _this$activeSubscript.currentPeriodEnd) === null || _this$activeSubscript === void 0 ? void 0 : _this$activeSubscript.formattedDateWithYear;
        if (!formattedEnd) return null;
        return "If you cancel now, your subscription will still be active until ".concat(formattedEnd, " but will not renew.");
      }
    }, {
      key: "otherSitesWarning",
      get: function get() {
        if (!_stores.SiteStore.hasIndexData || _stores.SiteStore.hasOutstandingRequests) return;
        var siteIds = _state.AppUI.user.userGroups.filter(function (ug) {
          return ug.id !== _state.AppUI.user.currentUserGroup.id;
        }).map(function (ug) {
          return ug.group.siteId;
        });
        if (siteIds.length === 0) return;
        var siteNames = _stores.SiteStore.indexData.filter(function (site) {
          return siteIds.includes(site.id);
        }).map(function (site) {
          return site.teamName;
        });
        if (siteNames.length <= 2) {
          return (0, _utils.niceJoin)(siteNames);
        }
        if (_state.AppUI.siteIsSeedlang) {
          return 'any Easy Languages sites';
        }
        var hasSeedlang = siteNames.includes('Seedlang');
        if (hasSeedlang) {
          return 'Seedlang and other Easy Languages sites';
        }
        return 'other Easy Languages sites';
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          activeSubscriptionIsMobile: this.activeSubscriptionIsMobile,
          activeSubscription: this.activeSubscription,
          userSubscriptions: this.userSubscriptions,
          showCancelButton: this.showCancelButton,
          mostRecentPaymentMethod: this.mostRecentPaymentMethod,
          loadSubscriptions: this.loadSubscriptions,
          loading: this.loading,
          activeStripeSubscriptionExists: this.activeStripeSubscriptionExists,
          otherSitesWarning: this.otherSitesWarning,
          subscriptionStatusText: this.subscriptionStatusText,
          cancellationNoticeText: this.cancellationNoticeText
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "loading", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "activeSubscription", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "activeSubscription"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "activeStripeSubscriptionExists", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "activeStripeSubscriptionExists"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "activeSubscriptionIsMobile", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "activeSubscriptionIsMobile"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mostRecentPaymentMethod", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "mostRecentPaymentMethod"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userSubscriptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "userSubscriptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showCancelButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showCancelButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "subscriptionStatusText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "subscriptionStatusText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cancellationNoticeText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cancellationNoticeText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "otherSitesWarning", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "otherSitesWarning"), _class2.prototype), _class2)) || _class;
};
SettingsBillingWrapper.displayName = 'SettingsBillingWrapper';
var _default = exports["default"] = SettingsBillingWrapper;